// extracted by mini-css-extract-plugin
export default {"button":"TaskPage_button__eAsKV","backButton":"TaskPage_backButton__v75Ow"};